import { FC, ReactNode, isValidElement } from 'react';
import { Typography } from '@mui/material';
import { COLORS } from '@cellebrite/saas-ui-common';

interface MarkedTextProps {
    children: ReactNode;
    searchText: string;
    containerProps?: object;
}

const MarkedText: FC<MarkedTextProps> = ({ children, searchText = '', containerProps }) => {
    if (!children) {
        return null;
    }
    const parsed = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return (
        <Typography
            noWrap
            dangerouslySetInnerHTML={{
                __html: (children as string)?.replaceAll(
                    new RegExp(parsed, 'gi'),
                    `<mark style="background-color: ${COLORS.WARNING_SOFT}">$&</mark>`,
                ),
            }}
            {...containerProps}
        ></Typography>
    );
};

export default MarkedText;
